import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import AccountDetail from '../AccountDetail';
import FieldDetail from '../FieldDetail';

export default function ErrorDetail({
  title,
  subTitle,
  accountHolder,
  accountNumber,
  fullAccountNumber,
  amount,
  bank
}) {
  return (
    <Grid
      columnSpacing="8px"
      container
      pb={{ xs: '24px', lg: '56px' }}
      pt={{ xs: '24px', lg: '32px' }}
      px={{ xs: '24px', lg: '32px' }}
      rowSpacing={{ xs: '16px', lg: '32px' }}
    >
      <Grid
        item
        xs={12}
      >
        <Stack
          direction="column"
          gap="8px"
        >
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Text
              color="primary"
              size="xl"
              weight="medium"
            >
              {title}
            </Text>
          </Stack>
          {subTitle && (
            <Text
              color="tertiary"
              size="sm"
            >
              {subTitle}
            </Text>
          )}
        </Stack>
      </Grid>
      <FieldDetail
        label="Account holder"
        lg={6}
        value={accountHolder}
        xs={12}
      />
      <FieldDetail
        label="Amount"
        lg={6}
        value={amount}
        xs={12}
      />
      <FieldDetail
        label="Bank"
        lg={6}
        value={bank}
        xs={12}
      />
      <AccountDetail
        accountNumber={accountNumber}
        fullAccountNumber={fullAccountNumber}
        label="Account"
      />
    </Grid>
  );
}

ErrorDetail.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  accountHolder: PropTypes.string,
  accountNumber: PropTypes.string,
  fullAccountNumber: PropTypes.string,
  amount: PropTypes.string,
  bank: PropTypes.string
};
